import PropTypes from 'prop-types';
import React from 'react';
import Styled from 'styled-components';

export const Content = Styled.div`
	z-index: 2;
	display: flex;
	flex-direction: row;
	align-items: center;
	height: 100%;
	width: 100%;
	padding: 0px 5px 0px 5px;
`;

const TagContainer = Styled.div`
	position: relative;
	
	font-family: ${({theme}) => theme.fontFamily};
	font-size: 10px;
	letter-spacing: 0.5px;
	font-weight: 500;
	
	box-sizing: border-box;
	max-width: calc(100% - 9px);
	height: 20px;
	margin-left: 9px;
	padding: 0 2px 0 2px;
	
	border-style: solid;
	border-width: 1px;
	border-radius: 4px;
	border-color: ${props => props.color};
	color: ${props => props.color};
	
	display: inline-block;
`;

export const Tag = ({color, name}) => {
	return (
		<TagContainer title={name} color={color}>
			<Content>{name}</Content>
		</TagContainer>
	);
};

Tag.propTypes = {
	color: PropTypes.string,
	name: PropTypes.string,
};
